<template>
	<r-standard-modal-form
		class="welcome-guide-helper-modal-outter"
		:style="{
			width: `264px`,
		}"
		@closeModal="$emit('closeModal')"
	>
		<span slot="title"> Exit your Welcome Guide? </span>
		<div slot="body" class="welcome-guide-helper-modal-body">
			<div class="subtitle-container">
				{{ message }}
			</div>
			<r-button 
				theme="white2" 
				fullWidth 
				class="continue-button" 
				@click="$emit('closeModal')"
			>
				Continue Welcome Guide
			</r-button>
			<r-button 
				theme="dark-blue" 
				fullWidth 
				class="exit-button" 
				@click="quitWelcomeGuide"
			>
				Exit Welcome Guide
			</r-button>
		</div>
	</r-standard-modal-form>
</template>
<script>

export default {
	name:'welcome-guide-helper-modal',
	data(){
		return{
		};
	},
	props:{
		dataStore:{
			required: true,
			type: Object,
		},
		message:{
			required: false,
			type: String,
			default: "You only have a few steps left!"
		},
	},
	computed:{
	},
	methods:{
		quitWelcomeGuide(){
			this.$emit('closeModal');
			this.dataStore.meta.showOnboarding = false;
		}
	},
}
</script>

<style scoped lang="scss">

.welcome-guide-helper-modal-outter{
	width: 100%;

	.welcome-guide-helper-modal-body{
		width: 100%;

		.subtitle-container{
			font-family: $rvFontFamily;
			font-size: 14px;
			line-height: 20px;
			letter-spacing: 0.15px;
			color: $p-color-grey-500;
			margin-bottom: 24px;
			position: relative;
			top: -12px;
		}

		.continue-button{
			margin-bottom: 12px;
		}

		.exit-button{
			margin-bottom: 12px;
		}
	}
}

</style>
